<template lang="pug">
div
  .pagination-wrapper.flex
    span Rows per table
    BriqMultiselect(
      :options="[10,25,50]"
      v-model="rowsPerTable"
      placeholder=""
      :showLabels="false"
      :searchable="false"
      )
    span {{ start }}-{{ finish }} of {{ total }}
    BriqButton.left-button(variant="secondary" @click="previous" :disabled="disablePrevious")
      BriqIcon(name="icon-arrow-leftright-icon")
    BriqButton.right-button(variant="secondary" @click="next" :disabled="disableNext")
      BriqIcon(name="icon-arrow-leftright-icon")
</template>

<script>
export default {
  name: 'BriqPagination',
  props: {
    total: Number,
    page: {
      type: Number,
      default: 1,
    },
    rowsPerTable: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    start() {
      return (this.page - 1) * this.rowsPerTable + 1
    },
    finish() {
      return this.page * this.rowsPerTable
    },
    disablePrevious() {
      return this.page === 1
    },
    maxPage() {
      return Math.ceil(this.total / this.rowsPerTable)
    },
    disableNext() {
      return this.page >= this.maxPage
    },
  },
  methods: {
    previous() {
      this.page -= 1
    },
    next() {
      this.page += 1
    },
  },
  watch: {
    page(newVal) {
      this.$emit('pageSelected', newVal)
    },
    rowsPerTable(newVal) {
      if (this.page >= this.maxPage) this.page = this.maxPage
      this.$emit('rowsPerTableSelected', newVal)
    },
  },
}
</script>

<style lang="stylus" scoped>
.pagination-wrapper
  display flex
  align-items center

.right-button, .left-button
  display flex
  padding 7px 12px
  margin-left 8px

.right-button
  transform rotate(180deg)
</style>

<style lang="stylus" scoped>
.briq-multiselect
  margin 0 10px
</style>
